import type {
  BadgeProps,
  BadgeShape,
  BadgeSize,
  BadgeVariant,
} from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { ColorField, SelectField, TextField } from "./fields.js";
import type { WidgetInspectorProps } from "./registry.js";

const VARIANT = ["solid", "outline", "subtle"] as const;
const SHAPE = ["pill", "square"] as const;
const SIZE = ["sm", "md", "lg"] as const;

export function BadgeInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as BadgeProps;

  return (
    <>
      <TextField
        label="Text"
        value={p.text}
        onChange={(v) => update(widget.id, { text: v })}
      />
      <SelectField
        label="Variant"
        value={p.variant ?? "solid"}
        options={VARIANT}
        onChange={(v) => update(widget.id, { variant: v as BadgeVariant })}
      />
      <SelectField
        label="Shape"
        value={p.shape ?? "pill"}
        options={SHAPE}
        onChange={(v) => update(widget.id, { shape: v as BadgeShape })}
      />
      <SelectField
        label="Size"
        value={p.size ?? "md"}
        options={SIZE}
        onChange={(v) => update(widget.id, { size: v as BadgeSize })}
      />
      <ColorField
        label="Colour"
        value={p.color ?? "#111827"}
        onChange={(v) => update(widget.id, { color: v })}
      />
      <ColorField
        label="Text colour (solid only)"
        value={p.textColor ?? "#ffffff"}
        onChange={(v) => update(widget.id, { textColor: v })}
      />
    </>
  );
}
